import { render, staticRenderFns } from "./SummaryCart.vue?vue&type=template&id=3d8f38dc&scoped=true"
import script from "./SummaryCart.vue?vue&type=script&lang=js"
export * from "./SummaryCart.vue?vue&type=script&lang=js"
import style0 from "./SummaryCart.vue?vue&type=style&index=0&id=3d8f38dc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8f38dc",
  null
  
)

export default component.exports